import React from 'react'
import StoryInspriationImg from '../../assets/images/webp/real-stories-impact-img.webp'
import BlueHeading from '../other/common/BlueHeading'
import Heading from '../common/ui/Heading';
const StoryInspriation = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="max-w-[1140px] mx-auto flex items-center justify-between max-xl:gap-14 max-lg:gap-10 max-md:gap-6 max-lg:flex-wrap-reverse">
          <div className="w-full max-w-[523px] max-lg:max-w-full">
            <img alt="stories" src={StoryInspriationImg} />
          </div>
          <div className="w-full max-w-[559px] max-lg:max-w-full">
            <BlueHeading lineClassOne="!hidden" text="Media & Interviews" />
            <Heading children="Every Word, Every Interview – A Story of Inspiration." />
            <p className="text-[#5E5C5C] text-[26px] max-md:text-base max-sm:text-sm font-normal leading-[150%] ff-jakarta pt-[16px]">
              Shri Deepak Ji, the founder and guiding light of Makeway India, is
              a living example for today’s youth. His thoughts, experiences, and
              life journey have been shared with great respect and enthusiasm
              across major YouTube channels, media houses, and podcast platforms
              throughout the country.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default StoryInspriation